<template>

    <div class="perks__sliders__container">

        <div class="perks__desktop__slider">
            
            <div class="icons">
                <div class="icon" v-for="perk, index in perks" v-bind:key="index" @mouseover="perkHoverSwitch(index)">
                    <img :src="perk.image" :alt="perk.title"/>
                    <p>{{ perk.number }}</p>
                </div>
            </div>
            <div class="content" id="current-perk-hovercontainer">
                <p class="order">{{ current_perk.number }}</p>
                <p class="title">{{ current_perk.title }}</p>
                <p class="desc">{{ current_perk.text }}</p>
            </div>

        </div>

        <div class="perks__mobile__slider">

            <!-- <img src="/images/icons/left.webp" class="perk__icon" @click="changePerk(-1)"> -->

            <div class="single__perk" id="perk_box">
                <div class="item__row">
                    <div class="left">
                        <img :src="this.current_perk.image" alt="perk image">
                        <div class="info first">
                            <p class="number">{{ this.current_perk.number }}</p>
                            <p class="text">{{ this.current_perk.title }}</p>
                        </div>
                    </div>
                    <div class="right">
                        <p>
                            {{ this.current_perk.text }}
                        </p>
                </div>
                    
            </div>

            <div class="progress__bar"><div id="teamprogress" class="in animate"></div></div>

            <!-- <img src="/images/icons/right.webp" class="perk__icon" @click="changePerk(1)"> -->
                    
            </div>

        </div>

    </div>

    
</template>
<script>
    export default {
        data(){
            return {
                perks: [
                    {
                        image: '/images/team/perks/01.webp',
                        number: "01",
                        title: 'Mens sana in corpore sano', 
                        text: "We care about health! Healthy nutrition and regular workout lead to a healthy and ready for challenges mind."
                    },
                    {
                        image: '/images/team/perks/02.webp',
                        number: "02",
                        title: 'Breaks help concentration', 
                        text: "Several researches have revealed that the average adult human is only able to fully concentrate on a task for a certain amount of time"
                    },
                    {
                        image: '/images/team/perks/03.webp',
                        number: "03",
                        title: 'Hard work pays off', 
                        text: "We believe in you and your growth within our company: bonuses, salary increase and paid employee trainings for any activity that is beneficial to your position at Gate21 is a must with us."
                    },
                    {
                        image: '/images/team/perks/04.webp',
                        number: "04",
                        title: 'Free Time', 
                        text: "Our company values work-life balance and offers paid holidays and vacation days as part of our benefits package."
                    }
                ],
                slider_index: 0,
                current_perk: {},
                autoplay_active: false
            }
        },
        created() {
            const viewport_width = window.innerWidth;
            if(viewport_width < 836) this.autoplay_active = true;
            this.setCurrentPerk(0);
        },
        mounted(){
        },
        methods:{ 
            changePerk(direction){
                if(direction === -1){
                    if(this.slider_index === 0){
                        this.setCurrentPerk(this.perks.length -1);
                    } else {
                        this.setCurrentPerk(this.slider_index - 1);
                    }
                    
                } else {
                    if(this.slider_index == this.perks.length - 1){
                        this.setCurrentPerk(0);
                    } else {
                        this.setCurrentPerk(this.slider_index + 1);
                    }
                }

                this.restartProgressBar();
            },

            setCurrentPerk(index){
                this.slider_index = index;
                this.current_perk = this.perks[index];

                if(this.autoplay_active){
                    setTimeout(() => {
                        document.getElementById('perk_box').classList.add('enlarge');
                    }, 1000);

                    setTimeout(() => {
                        document.getElementById('perk_box').classList.remove('enlarge');
                    }, 12000);

                    setTimeout(() => {
                        this.changePerk(1);
                    }, 12500)
                }

               
            },

            restartProgressBar(){
                const bar = document.getElementById('teamprogress');
                if(bar.classList.contains('animate')) {
                    bar.style.animation = 'none';
                    bar.offsetHeight; /* trigger reflow */
                    bar.style.animation = null; 
                    bar.classList.remove('animate'); 
                    bar.classList.add('animate');
                }
            },

            perkHoverSwitch(index){

                if(this.current_perk.number != '0' + (index + 1)){
                    const container = document.getElementById('current-perk-hovercontainer');
                    container.classList.add('disappear');

                    setTimeout(() => {
                        container.classList.remove('disappear');
                    }, 200);

                    this.setCurrentPerk(index);
                }
                
            }
        }
    }
</script>
<style scoped lang="scss">

    .perks__sliders__container{

        .perks__desktop__slider{
            display: flex;
            flex-direction: row;
            justify-content: center;

            .icons{
                width:160;
                height:158px;
                // background-color:#fff;
                display:grid;
                grid-template-columns: 78px 77px;
                grid-row: auto auto;
                grid-column-gap: 5px;
                grid-row-gap: 5px;
                cursor: pointer;


                .icon{
                    position: relative;

                    border: 1px solid #ED1163;
                    transition: all .3s ease;

                    &:hover{
                        background: #ED1163;
                    }

                    img{
                        display: block;
                        width: 30px;
                        height: 30px;
                        margin: auto;
                        margin-top: 18px;
                    }

                    p{
                        position: absolute;
                        bottom: 5px;
                        right: 5px;

                        font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;;
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 22px;
                        line-height: 18px;
                        margin: 0;

                        color: white;
                    }
                }
            }

            .content{
                display: flex;
                flex-direction: column;
                border-top: 2px solid #ED1163;
                width: 425px;
                margin-left: 12px;
                opacity: 1;
                transition: all .2s ease;
                padding-left: 5px;

                &.disappear{
                    opacity: 0.5;
                }

                .order{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;;
                    font-style: normal;
                    font-size: 32px;
                    line-height: 18px;
                    margin: 0;
                    margin-top: 20px;
                    color: white;
                }

                .title{
                    font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 20px;
                    line-height: 18px;
                    margin: 0;
                    // margin-bottom: 23px;
                    margin-bottom: 16px;
                    color: white;
                    text-transform: uppercase;
                    margin-top: 11px;
                }

                .desc{
                    font-family: 'DIN Next LT Pro Ultralight', Tahoma, Verdana, sans-serif;;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 18px;
                    margin: 0;
                    color: white;
                }
            }
        }

        .perks__mobile__slider{
            display: none;
            flex-direction: row;
            justify-content: space-between;

            .perk__icon{
                width: 35px;
                height: 35px;
                display: block;
                margin-top: auto;
                margin-bottom: auto;
                cursor: pointer;
            }

            .single__perk{
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                // width: 205px;
                // height: 192px;
                height: 200px;
                position: relative;

                margin-left: auto;
                margin-right: auto;

                transform: scale3d(0, 0, 0);
                
                transition: all .3s ease;

                &.enlarge{
                    transform: scale3d(1, 1, 1);
                }

                .item__row{
                    display: flex;
                    flex-direction: row;

                    .left{
                        img{
                            display: block;
                            width: 75px;
                            height: 75px;
                            margin-left: auto;
                            margin-right: auto;
                            margin-top: 12px;
                            margin-bottom: 12px;
                        }

                        .info{
                            display: flex;
                            flex-direction: row;
                            position: relative;
                            border-top: 2px solid #ED1163;
                            overflow: hidden;
                            margin-bottom: 8px;

                            .number{
                                font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                                font-style: normal;
                                // font-weight: 400;
                                font-size: 35px;
                                line-height: 35px;
                                text-align: center;
                                text-transform: uppercase;

                                color: #FFFFFF;
                                margin: 0;
                                margin-top: 13px;
                            }

                            .text{
                                font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                                font-style: normal;
                                // font-weight: 400;
                                font-size: 16px;
                                line-height: 16px;
                                text-transform: uppercase;

                                color: #FFFFFF;
                                margin: 0;
                                width: 155px;
                                margin-top: 13px;
                                margin-left: 5px;
                            }
                        }
                    }

                    .right{
                        width: 100%;
                        max-width: 435px;
                        // margin-left: 14px;
                        border-top: 2px solid #ED1163;
                        border-left: 2px solid #ED1163;

                        p{
                            font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            // font-weight: 400;
                            font-size: 16px;
                            line-height: 18px;
                            text-align: left;

                            margin: 0;
                            padding-left: 12px;
                            padding-top: 12px;

                            color: #FFFFFF;
                        }
                    }
                }

                .progress__bar{
                    height: 3px;
                    width: 100%;
                    position: relative;
                    z-index: 1;
                    
                    .in {
                        height: 100%;
                        background-color: #ED1163;
                        width: 0%;

                        // start the animation
                        &.animate{
                            animation: fill 12s linear;
                        }
                    }

                    @keyframes fill {
                        0% {
                            width: 0%;
                        }
                        100% {
                            width: 100%;
                        }
                    }
                }
            }
        }

    }



    
    @media screen and (max-width: 836px) {

        .perks__sliders__container{

            .perks__desktop__slider{
                display: none;
            }

            .perks__mobile__slider{
                display: flex;
                flex-direction: column;
                height: 400px;

                .single__perk{
                    margin-left: auto;
                    margin-right: auto;
                    margin-bottom: 25px;

                    height: auto;

                    .item__row{
                        flex-direction: column;
                        overflow-x: hidden;

                        .left{

                            img{
                                margin-top: 24px;
                                margin-bottom: 48px;
                            }

                            .info{
                                border-right: 2px solid #ED1163;
                                margin-bottom: 0;

                                .number, .text{
                                    margin-bottom: 8px;
                                }
                            }

                        }

                        .right{

                            p{
                                margin-bottom: 12px;
                            }
                        }
                    }
                }
            }

        }

    }

</style>